import { useQuery } from "@tanstack/react-query";
import * as api from "../api/registration.api";

export const MASTER_QUERY_KEYS = {
	roles: ["master", "roles"],
	genders: ["master", "genders"],
	qualifications: ["master", "qualifications"],
	levels: ["master", "levels"],
	urbanBodyTypes: ["master", "urbanBodyTypes"],
	districts: ["master", "districts"],
	blocks: (districtId?: string | number) => ["master", "blocks", districtId],
	bloodGroups: ["master", "bloodGroups"],
	castes: ["master", "castes"],
	recruitmentTypes: ["master", "recruitmentTypes"],
	religions: ["master", "religions"],
	schemes: ["master", "schemes"],
	villages: (blockId?: string | number) => ["master", "villages", blockId],
};

const STALE_TIME = 1000 * 60 * 60; // 1 hour for master data

export const useRoles = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.roles,
		queryFn: api.fetchRoles,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useGenders = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.genders,
		queryFn: api.fetchGenders,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useLevels = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.levels,
		queryFn: api.fetchLevels,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useUrbanBodyTypes = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.urbanBodyTypes,
		queryFn: api.fetchUrbanBodyTypes,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useDistricts = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.districts,
		queryFn: api.fetchDistricts,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useBlocks = (districtId?: string | number) =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.blocks(districtId),
		queryFn: () => api.fetchBlocks(districtId),
		enabled: !!districtId,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useBlocksList = () =>
	useQuery({
		queryKey: ["master", "blocks", "list"],
		queryFn: api.fetchBlocksList,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useBloodGroups = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.bloodGroups,
		queryFn: api.fetchBloodGroups,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useCastes = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.castes,
		queryFn: api.fetchCastes,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useRecruitmentTypes = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.recruitmentTypes,
		queryFn: api.fetchRecruitmentTypes,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useReligions = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.religions,
		queryFn: api.fetchReligions,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useSchemesMaster = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.schemes,
		queryFn: api.fetchSchemes,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useVillages = (blockId?: string | number) =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.villages(blockId),
		queryFn: () => api.fetchVillages(blockId!),
		enabled: !!blockId,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});

export const useQualifications = () =>
	useQuery({
		queryKey: MASTER_QUERY_KEYS.qualifications,
		queryFn: api.fetchQualifications,
		staleTime: STALE_TIME,
		refetchOnWindowFocus: false,
	});
